export const device = {
    exsm:'(max-width: 575px)',
    sm: '(min-width: 576px) and (max-width: 767px)',
    md: '(min-width: 768px) and (max-width: 991px)',
    lg: '(min-width: 992px) and (max-width: 1200px)',
    exlg:'(min-width: 1201px)',
  };